import { Navigation } from "./navigation";
import { Collapse, Alert } from "bootstrap";
import { Newsletter } from "./newsletter";
import { Forms } from "./forms";
import { Header } from "./header";
import { SectionAnimations } from "./section-animations";
import { BackToTop } from "./back-to-top";
import { StatWidget } from "./widgets/stat-widget";
import { Filters } from "./filters";
import { VideoPlayer } from "./video-player";
import { Accordion } from "./accordion";
import { Product } from "./pages/product";
import { Distributors } from "./pages/distributors";
import { ProductList } from "./pages/product-list";
import { CookieBanner } from "./cookie-banner";
import { ResourceList } from "./pages/resource-list";
import { SuccessStoryList } from "./pages/success-story-list";
import {Carousel} from "./carousel";
import { TeamMembersList } from "./pages/team-member-list";
import { CountryStateSelector } from "./country-state-selector";
import { DismissableNotice } from "./dismissable-notice";
import { TabHelper } from "./helpers/tab-helper";
import { EventCalendar } from "./widgets/event-calendar";
import { TeamMemberWidget } from "./widgets/team-member-widget";
import { SocialShare } from "./social-share";
import { DistributorModal } from "./widgets/distributor-modal";  
import {ConsentBanner} from "./consent-banner";
import {ArticleList} from "./pages/article-list";
import {ResearchList} from "./pages/research-list";
import {SuccessStoriesMap} from "./widgets/sucess-stories-map";
import {ResourceListFactory} from "./pages/resource-list-factory";
import {Users} from "./users";                               
import {TabbedTable} from "./widgets/tabbed-table";
import {Search} from "./search";


export class App {

	constructor() {

		const init = [
			new Newsletter(),
			new Forms(),
			new Header(true),
			new CountryStateSelector(),
			new Navigation(true),
			new SectionAnimations(),
			new BackToTop(),
			new StatWidget(),
			new Filters(),
			new VideoPlayer(),
			new Accordion(),
			new Product(),
			new Distributors(),
			new TabHelper(),
			new ProductList(),
			new ResourceListFactory(),			
			new SuccessStoryList(),
			new TeamMembersList(),			
			new DismissableNotice(),
			new SocialShare(),
			new Carousel(),
			new EventCalendar(),
			new TeamMemberWidget(),
			new DistributorModal(),
			new ConsentBanner(),
			new ArticleList(),
			new ResearchList(),
			new Users(),
			new TabbedTable(), 
			new Search()
		];

		const bootstrapInit = [Alert, Collapse]; //bootstrap used methods
	}

}


function documentReady(fn: () => void) {
	if (document.readyState === "complete" || document.readyState === "interactive") {
		setTimeout(fn, 1);
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}


documentReady(() => {
	new App();
});

